import { render, staticRenderFns } from "./Setup_Airlines.vue?vue&type=template&id=0217a70a&scoped=true&"
import script from "./Setup_Airlines.vue?vue&type=script&lang=js&"
export * from "./Setup_Airlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0217a70a",
  null
  
)

export default component.exports